import Service from "../../services"

const News = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        getNewsList({commit},page) {
            return Service.News.getNewsList(page).then(res => {
                return res;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
        getNewsByID({commit}, id){
            return Service.News.getNewsByID(id).then(data =>{
                return data;
            }).catch(err=>{
                return Promise.reject(err);
            })
        },
        deleteNewsByID({commit}, id){
            return Service.News.deleteNewsByID(id).then(data =>{
                return data;
            }).catch(err=>{
                return Promise.reject(err);
            })
        },
        updateNewsByID({commit},data){
            return Service.News.updateNewsByID(data.id,data).then(res =>{
                return res;
            }).catch(err=>{
                return Promise.reject(err);
            })
        },
        save({commit}, data) {
            return Service.News.save(data).then(res => {
                return res;
            })
        },
        uploadImage({commit}, data) {
            return Service.News.uploadImage(data).then(data => {
                return data;
            }).catch(err => {
                return Promise.reject(err)
            })
        },
    },
}

export default News;
